export const login_content_card_style = {
  CardcontentSx: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 8px 69px #0000001A',
    borderRadius: '12px',
    px: 4,
    py: 5,
    mt: 2.5,
    width: '435px',
  },
  logowithtextSx: {
    display: 'flex',
    alignItems: 'center',
  },
  companytypoSx: {
    color: '#007965',
    textTransform: 'capitalize',
    fontSize: '16px',
    fontWeight: 600,
  },
  createPasswordSx: {
    fontSize: '20px',
    color: 'text.primary',
    textAlign: 'left',
    fontWeight: 600,
    py: 1.5,
  },
  hcLogoSx: {
    ml: -1.15,
  },
  forgotPasswordTextSx: {
    fontSize: '14px',
    color: 'primary.main',
    textAlign: 'right',
    fontWeight: 600,
    pt: 2,
    pb: 1.5,
    cursor: 'pointer',
  },
  inputGroupSx: {
    pt: 1.5,
  },
  buttonStyleSx: {
    textTransform: 'capitalize',
  },
  eyeSx: {
    width: '20px',
    height: '20px',
  },
};
